/**
 * The R4 control: a labeled stepper for the pick requirement a revived entry
 * owes per round, defaulting to the contest's own value. Minimum 1, no
 * maximum (D-h, `plan.md` `## 2`) , a raised pick requirement is controlled
 * socially rather than mechanically.
 *
 * Local to this feature rather than a `@sportsmet/ui` export (D-i): one
 * consumer today.
 */
import { Button } from "@sportsmet/ui";
import type { JSX } from "react";

import { pickRequirementHelp, pickRequirementLabel } from "./reviveSheetModel";

export type typePickRequirementStepperProps = {
  name: string;
  value: number;
  onChange: (next: number) => void;
  disabled?: boolean | undefined;
};

export function PickRequirementStepper(
  props: typePickRequirementStepperProps,
): JSX.Element {
  const { name, value, onChange, disabled = false } = props;

  return (
    <div className="flex flex-col gap-2">
      <span className="text-body-strong text-ink">
        {pickRequirementLabel({ name })}
      </span>
      <div className="flex items-center gap-3">
        <Button
          variant="secondary"
          size="icon"
          aria-label="Fewer picks"
          data-testid="revive-picks-decrement"
          disabled={disabled || value <= 1}
          onClick={() => {
            onChange(value - 1);
          }}
        >
          -
        </Button>
        <span
          data-testid="revive-picks-value"
          className="min-w-8 text-center text-body-strong text-ink"
        >
          {value}
        </span>
        <Button
          variant="secondary"
          size="icon"
          aria-label="More picks"
          data-testid="revive-picks-increment"
          disabled={disabled}
          onClick={() => {
            onChange(value + 1);
          }}
        >
          +
        </Button>
      </div>
      <p className="text-caption text-ink-secondary">
        {pickRequirementHelp({ name })}
      </p>
    </div>
  );
}
